(() => {
  const root = document.querySelector('[data-section="for-good"]');
  if (!root) return;
  const form = root.querySelector('.fg-form');
  if (form && !form.dataset.fgReady) {
    const update = () => {
      const selected = form.querySelector('[data-fg-type]:checked')?.dataset.fgType;
      form.querySelectorAll('[data-fg-fields]').forEach((group) => {
        const active = group.dataset.fgFields === selected;
        group.hidden = !active;
        group.querySelectorAll('input, select, textarea').forEach((control) => {
          control.disabled = !active;
          control.required = active && control.hasAttribute('data-fg-required');
        });
      });
    };
    form.dataset.fgReady = 'true';
    form.addEventListener('change', update);
    window.addEventListener('pageshow', update);
    update();
  }
  // Motion support must not gate application form behavior.
  if (root.classList.contains('fg-motion') || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const targets = root.querySelectorAll('[data-fg-reveal], [data-fg-reveal-img]');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  root.classList.add('fg-motion');
  targets.forEach((target) => observer.observe(target));
})();
